<template>
  <div class="question-view img-drag" >
    <div class="quest">
      <div class="title">
        <vue-mathjax :formula="form.title" @onRenderComplete="mathjaxRes" :safe="false"/>
      </div>
      <div class="img-show">
        <div :class="['single', existImage.includes(idx) && 'disabled']" v-for="(item, idx) in imageList" :key="idx" :draggable="(item.image && !existImage.includes(idx)) ? 'true' : 'false'" @dragstart="dragstart($event, idx)">
          <img :src="item.image" v-if="item.image" alt=""> 
        </div>
      </div>
    </div>
    <div class="quest-img" :style="{backgroundImage: `url(${form.img_url})`}">
      <!-- <img :src="form.img_url" alt=""> -->
    </div>

  </div>
</template>

<script>
import ImgDrag from './imgDrag/imgDrag';

export default {
  props: ['form'],
  data() {
    return {
      image: '',
      topic: '',
      imageList: [],
      existImage: [],

      drag: null
    }
  },
  methods: {
    mathjaxRes() {
      // console.log('圖片拖拽题')
      this.$emit('onRenderComplete')
    },
    addRegion() {
      this.drag.createBlock()
    },

    dragstart(e, idx) {
      e.dataTransfer.setData('info', idx)
    },
  },
  created() {

  },
  mounted() {
    this.drag = new ImgDrag({
      plate: '.quest-img',
      useType: 'view',
    })

    let content = JSON.parse(this.form.content)
    // 过滤未上传圖片的区域
    content.imageList = content.imageList.filter(its => its.image && its)
    console.log(content)
    this.imageList = content.imageList
    // 将图片列表顺序打乱
    for(let i = 0; i < this.imageList.length; i++) {
      let random = Math.floor(Math.random() * this.imageList.length)

      // 替换位置
      if(random != i) {
        [this.imageList[i], this.imageList[random]] = [this.imageList[random], this.imageList[i]]
      }
    }
    this.drag.echoBlock(content.imageList, this)
  }
}
</script>

<style scoped lang="scss">
.question-view {
  width: 100%;
  height: 100%;
  padding: 0px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  .quest {
    width: calc(55% - 10px);
    height: 100%;

    .title {
      font-size: 15px;
      color: #333;
    }

    .img-show {
      width: 260px;
      display: flex;
      align-content: flex-start;
      flex-wrap: wrap;
      margin-top: 10px;
    }

    .single {
      width: 100px;
      height: 100px;
      margin: 10px 10px 0 0;
      border-radius: 10px;
      // background-color: #f8ae64;
      box-shadow: 0 2px 3px 2px #ccc;
      overflow: hidden;
      cursor: pointer;

      img {
        max-width: 100%;
        max-height: 100%;
        width: 100%;
        height: 100%;
        object-fit: contain;
        user-select: none;
        -webkit-user-drag: none;
      }
    }

    .disabled {
      opacity: .4;
      cursor: not-allowed;
    }
  }
  .quest-img {
    width: 493px;
    height: 300px;
    background-color: #fff;
    position: relative;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 5px;
    .img-region {
      position: relative;
      display: flex;
      overflow: hidden;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        position: absolute;
        background-color: #fff;
        color: #333;
      }

      &:after, &:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: -50%;
        margin: auto;
        height: 1px;
        width: 200%;
        background-color: #fff;
        transform: rotateZ(45deg);
      }

      &:before {
        transform: rotateZ(-45deg);
      }
    }

    img {
      width: 100%;
      height: 100%;
      user-select: none;
      -webkit-user-drag: none;
    }

  }
}
</style>

<style lang="scss">
.img-drag {
  .block-style {
    width: 80px;
    height: 80px;
    position: absolute;
    top: 80px;
    left: 80px;
    cursor: pointer;
    z-index: 1;
    background-size: 100% 100%;
    
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 1px solid #333;
    }

    .success, .error {
      position: absolute;
      bottom: -5px;
      right: -5px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #007416;
      display: none;
    }

    .success {
      &:before {
        content: '';
        color: #fff;
        position: absolute;
        top: -5px;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 10px;
        height: 6px;
        border: 2px solid #fff;
        border-top: none;
        border-right: none;
        transform: rotateZ(-50deg);
        transform-origin: center center;
      }
    }

    .error {
      background-color: #d60215;

      &:before, &:after {
        content: '';
        width: 10px;
        height: 2px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        transform: rotateZ(-45deg);
        transform-origin: center center;
        background-color: #fff;
      }

      &:after {
        transform: rotateZ(45deg);
      }
    }
  }
}
</style>